import { Injectable } from "@angular/core";
import { FeatureFlagsService as ffService } from "@cotecna/feature-manager";

@Injectable({
  providedIn: "root",
})
export class FeatureFlagsService {
  constructor(public featureFlagsService: ffService) {}

  public isTimelogTabEnabled(): boolean {
    return this.featureFlagsService.isActive(
      FeatureFlag.Y22_S13_SHOW_TIMELOG_TAB,
    );
  }

  public isGeolocationFeatureEnabled(): boolean {
    return this.featureFlagsService.isActive(
      FeatureFlag.Y22_S13_ENABLE_GEOLOCATION_FEATURE,
    );
  }

  public showMaintenanceMessage(): boolean {
    return this.featureFlagsService.isActive(
      FeatureFlag.Y22_S13_SHOW_MAINTENANCE_MESSAGE,
    );
  }

  public showInspectionsFilter(): boolean {
    return this.featureFlagsService.isActive(
      FeatureFlag.Y22_S17_SHOW_INSPECTIONS_FILTER,
    );
  }

  public showUserInfo(): boolean {
    return this.featureFlagsService.isActive(
      FeatureFlag.Y22_S22_SHOW_USER_INFO,
    );
  }

  public allowSharePictures(): boolean {
    return this.featureFlagsService.isActive(
      FeatureFlag.Y23_S19_ALLOW_SHARE_PICTURES,
    );
  }

  public allowHistoryLogTab(): boolean {
    return this.featureFlagsService.isActive(
      FeatureFlag.Y25_S11_ALLOW_HISTORY_LOG_TAB,
    );
  }
}

export enum FeatureFlag {
  Y22_S13_SHOW_TIMELOG_TAB = "Y22_S13_SHOW_TIMELOG_TAB",
  Y22_S13_ENABLE_GEOLOCATION_FEATURE = "Y22_S13_ENABLE_GEOLOCATION_FEATURE",
  Y22_S13_SHOW_MAINTENANCE_MESSAGE = "Y22_S13_SHOW_MAINTENANCE_MESSAGE",
  Y22_S17_SHOW_INSPECTIONS_FILTER = "Y22_S17_SHOW_INSPECTIONS_FILTER",
  Y22_S22_SHOW_USER_INFO = "Y22_S22_SHOW_USER_INFO",
  Y23_S19_ALLOW_SHARE_PICTURES = "Y23_S19_ALLOW_SHARE_PICTURES",
  Y25_S11_ALLOW_HISTORY_LOG_TAB = "Y25_S11_ALLOW_HISTORY_LOG_TAB",
}
